

// import Layout from "components/ui/Layout";
// import { useSupportChats } from "features/supportChat/hooks/useSupportChats";
// import { supportChatServices } from "features/supportChat/services/supportChat.service";
// import { connectSocket, getSocket, disconnectSocket } from "features/supportChat/socket/socket";
// import Cookies from "js-cookie";
// import { useEffect, useState, useRef, useCallback } from "react";
// import {

//   useAuth

// }

//   from

//   "../../contexts/AuthContext";



// // ---------------------------------------------------------------------------
// // Pass currentAdminId from your auth context / store.
// // e.g. const currentAdminId = useSelector(state => state.auth.user._id)
// // ---------------------------------------------------------------------------

// const SupportChat = () => {

//   const {

//     user

//   } =

//     useAuth();


//   const currentAdminId =

//     user?._id;

//   const { data, isLoading } = useSupportChats();

//   // ── State ─────────────────────────────────────────────────────────────────

//   const [chats, setChats] = useState([]);
//   const [reloading, setReloading] = useState(false);
//   const [selectedChat, setSelectedChat] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [

//     selectedImage,

//     setSelectedImage

//   ] =

//     useState(null);
//   const [input, setInput] = useState("");
//   const [selectedFile,
//     setSelectedFile] =

//     useState(null);

//   const [uploading,
//     setUploading] =

//     useState(false);
//   const [isUserTyping, setIsUserTyping] = useState(false);
//   const [onlineUsers, setOnlineUsers] = useState({});

//   const [

//     imageLoaded,

//     setImageLoaded

//   ] =

//     useState({});

  

//   // ── Refs ──────────────────────────────────────────────────────────────────

//   const messagesEndRef = useRef(null);
//   const typingTimeoutRef = useRef(null);
//   const currentRoomRef = useRef(null); // tracks the room the socket is currently joined to
//   const selectedChatRef = useRef(null);
//   const fileInputRef = useRef(null);
//   selectedChatRef.current = selectedChat;

//   // ── Sync chats list from query ─────────────────────────────────────────────

//   useEffect(() => {
//     if (data?.data) setChats(data.data);
//   }, [data]);

//   useEffect(() => {
//     if (messages.length > 0) {
//       scrollToBottom("instant");
//     }
//   }, [messages.length]);

//   // ── Helpers ───────────────────────────────────────────────────────────────

//   const scrollToBottom = (behavior = "smooth") => {
//     setTimeout(() => {
//       messagesEndRef.current?.scrollIntoView({ behavior });
//     }, 80);
//   };

//   const getClientName = (chat) => {
//     const p = chat?.participant1;
//     if (!p) return "Unknown";
//     const name = [p.firstName, p.lastName].filter(Boolean).join(" ");
//     return name || p.phoneNumber || p.email || "Unknown";
//   };

//   const getClientInitial = (chat) => {
//     const p = chat?.participant1;
//     if (!p) return "U";
//     return p.firstName?.[0] || p.phoneNumber?.[0] || "U";
//   };

//   const getAssignedAdminId = (chat) => {
//     if (!chat?.participant2) return null;
//     return typeof chat.participant2 === "string"
//       ? chat.participant2
//       : chat.participant2._id;
//   };


//   const getMediaType =
//     (file) => {

//       if (
//         file.type.startsWith(
//           "image/"
//         )
//       ) {

//         return "image";

//       }

//       if (
//         file.type.startsWith(
//           "video/"
//         )
//       ) {

//         return "video";

//       }

//       if (
//         file.type.startsWith(
//           "audio/"
//         )
//       ) {

//         return "audio";

//       }

//       return "document";

//     };

// useEffect(() => {
//   const hasReloaded = sessionStorage.getItem("supportChatReloaded");

//   if (!hasReloaded) {
//     setReloading(true);
//     sessionStorage.setItem("supportChatReloaded", "true");
//     // Small delay so the loader renders before reload fires
//     const t = setTimeout(() => {
//       window.location.reload();
//     }, 100);
//     return () => clearTimeout(t);
//   }

//   return () => {
//     sessionStorage.removeItem("supportChatReloaded");
//   };
// }, []);

//   // ── Connect socket ONCE on mount — all listeners registered here ───────────

//   useEffect(() => {
//     const token = Cookies.get("accessToken");
//     if (!token) {
//     console.warn("No access token found — skipping socket connection");
//     return;
//   }
//     const socket = connectSocket(token);

//     // Historical messages — fired by server after joinChat
//     socket.on(
//       "allMessages",

//       (payload) => {


//         // console.log(
//         //   "ALL MESSAGES RECEIVED"
//         // );

//         // console.log(
//         //   payload
//         // );

//         setMessages(

//           (

//             payload.messages

//             ||

//             []

//           )

// .map(msg => ({
//   ...msg,
//   markAsRead: msg.markAsRead ?? msg.isRead ?? false
// }))

//         );

//         scrollToBottom("instant");
//       }
//     );

//     // Real-time incoming messages
//     socket.on("newMessage", (message) => {
//       console.log(
//         "Incoming message:",
//         message
//       );

//       console.log(
//         "Current room:",
//         currentRoomRef.current
//       );

//       const activeRoom =
//         currentRoomRef.current;



//       // Update sidebar

//       setChats((prev) =>
//         prev.map((chat) => {

//           if (
//             chat._id !==
//             message.chatId
//           ) {
//             return chat;
//           }

//           const isActiveRoom =
//             activeRoom ===
//             message.chatId;

//         // REPLACE WITH THIS:
// const prevUnread = chat.unreadCount?.[currentAdminId] || 0;

// const isUnread =
//   message.isRead === false &&
//   !isActiveRoom &&
//   message.senderType !== "admin";

// return {
//   ...chat,
//   lastMessage: message,
//   unreadCount: {
//     ...chat.unreadCount,
//     [currentAdminId]: isUnread ? prevUnread + 1 : isActiveRoom ? 0 : prevUnread,
//   },
// };
//         })
//       );

//       // Update messages area

//       if (
//         activeRoom ===
//         message.chatId
//       ) {

//         setMessages(
//           (prev) => {

//             const exists =
//               prev.some(
//                 (m) =>
//                   m._id ===
//                   message._id
//               );

//             if (
//               exists
//             ) {
//               return prev;
//             }

// return [
//   ...prev,
//   {
//     ...message,
//     markAsRead: message.markAsRead ?? message.isRead ?? false
//   }
// ];

//           }
//         );

//         scrollToBottom();

//       // REPLACE WITH THIS:
// socket.emit("markMessagesRead", { chatId: message.chatId });

// // Optimistically clear unread for active room
// setChats(prev =>
//   prev.map(c =>
//     c._id === message.chatId
//       ? { ...c, unreadCount: { ...c.unreadCount, [currentAdminId]: 0 } }
//       : c
//   )
// );
//       }
//     });

//     // Online / offline
//     socket.on("userStatus", (data) => {
//       setOnlineUsers((prev) => ({ ...prev, [data.userId]: data.isOnline }));
//     });

//     // Typing
//     socket.on("typing", (data) => {
//   const activeChat = selectedChatRef.current;
//   const clientId = activeChat?.participant1?._id;
//   const activeChatId = activeChat?._id;

//   // Only show typing if it's from the current chat's participant
//   // AND it's for the currently open chat room
//   if (data.userId === clientId && data.chatId === activeChatId) {
//     setIsUserTyping(data.isTyping);
//   } else if (data.chatId !== activeChatId) {
//     // Always clear typing when switching chats or event is from another room
//     setIsUserTyping(false);
//   }
// });

//     socket.on(
//       "messagesRead",

//       (data) => {

//         setChats(
//           prev =>

//             prev.map(
//               chat =>

//                 chat._id ===
//                   data.chatId

//                   ?

//                   {

//                     ...chat,

//                     unreadCount: {

//                       ...chat.unreadCount,

//                       [currentAdminId]:

//                         0

//                     }

//                   }

//                   :

//                   chat

//             )

//         );

//       }

//     );

//     // ADD THIS after socket.on("messagesRead", ...) :
// socket.on("totalUnreadCount", (data) => {
//   // console.log("totalUnreadCount payload:", data);
//   // This acts as a correction layer —
//   // if frontend count drifts, server resyncs it.

//   // Shape: { chatId, count } — adjust if your server sends differently
//   if (data?.chatId && typeof data?.count === "number") {
//     setChats(prev =>
//       prev.map(chat =>
//         chat._id === data.chatId
//           ? {
//               ...chat,
//               unreadCount: {
//                 ...chat.unreadCount,
//                 [currentAdminId]: isNaN(data.count) ? 0 : data.count,
//               },
//             }
//           : chat
//       )
//     );
//   }
// });

//    socket.on("messageSeen", (data) => {
//   // Guard: only update if the seen event is for the currently open chat
//   if (data.chatId && data.chatId !== currentRoomRef.current) return;

//   setMessages(prev =>
//     prev.map(msg =>
//       data.messageIds?.includes(msg._id)
//         ? { ...msg, markAsRead: true }
//         : msg
//     )
//   );
// });

//     return () => {

//       socket.off(
//         "allMessages"
//       );

//       socket.off(
//         "newMessage"
//       );

//       socket.off(
//         "userStatus"
//       );

//       socket.off(
//         "typing"
//       );

//       socket.off(
//         "messagesRead"
//       );

//       socket.off("totalUnreadCount");


//       socket.off(
//         "messageSeen"
//       );

//       currentRoomRef.current =
//         null;

//       disconnectSocket();
//     };
//   }, [currentAdminId]);

//   // ── Select a chat room ────────────────────────────────────────────────────

//   const handleSelectChat =
//     useCallback(

//       (chat) => {

//         const socket =
//           getSocket();

//         if (
//           !socket
//         ) {
//           return;
//         }

//         // console.log(
//         //   "Joining room:",
//         //   chat._id
//         // );

//         // Leave old room

//         if (

//           currentRoomRef.current &&

//           currentRoomRef.current !==
//           chat._id

//         ) {

//           socket.emit(

//             "leaveChat",

//             {

//               chatId:

//                 currentRoomRef.current,

//             }
//           );
//         }

//         currentRoomRef.current =
//           chat._id;

//         setSelectedChat(
//           chat
//         );

//         handleAssign(chat._id);


//         //  setChats(
//         //  prev=>

//         //  prev.map(
//         //    c=>

//         //    c._id===chat._id

//         //    ? {

//         //       ...c,

//         //       unreadCount:{

//         //         ...c.unreadCount,

//         //         [currentAdminId]:
//         //         0

//         //       }

//         //      }

//         //    :

//         //    c

//         //  )

//         // );

//         setChats(prev =>
//   prev.map(c =>
//     c._id === chat._id
//       ? { ...c, unreadCount: { ...c.unreadCount, [currentAdminId]: 0 } }
//       : c
//   )
// );

//         setMessages(
//           []
//         );

//         scrollToBottom("instant");


//         setInput(
//           ""
//         );

//         setIsUserTyping(
//           false
//         );

//         if (typingTimeoutRef.current) {
//   clearTimeout(typingTimeoutRef.current);
//   typingTimeoutRef.current = null;
// }

//         // console.log(
//         //   "Joining room:",
//         //   chat._id
//         // );

//         socket.emit(

//           "joinChat",

//           {

//             chatId:

//               chat._id

//           }

//         );

//         socket.emit(

//           "markMessagesRead",

//           {

//             chatId:
//               chat._id,

//           }

//         );

//       },

//       [
//         currentAdminId
//       ]

//     );

//   // ── Send message ──────────────────────────────────────────────────────────

//   const handleSendMessage =
//     async () => {

//       if (

//         !selectedChat ||

//         (
//           !input.trim() &&

//           !selectedFile
//         )

//       ) {

//         return;

//       }

//       const socket =
//         getSocket();

//       let mediaUrl =
//         null;

//       let mediaType =
//         null;

//       try {

//         setUploading(
//           true
//         );

//         if (
//           selectedFile
//         ) {

//           const uploadResponse =

//             await supportChatServices
//               .uploadSupportFile(
//                 selectedFile
//               );

//           mediaUrl =

//             uploadResponse
//               .data
//               .key;

//           mediaType =

//             getMediaType(
//               selectedFile
//             );

//         }

//         socket.emit(

//           "sendMessage",

//           {

//             chatId:

//               selectedChat._id,

//             content:

//               input.trim(),

//             mediaUrl,

//             mediaType,

//             markAsRead:

//               false

//           }

//         );

//         socket.emit(

//           "typing",

//           {

//             chatId:

//               selectedChat._id,

//             isTyping:

//               false

//           }

//         );

//         setInput("");

//         setSelectedFile(
//           null
//         );

//         if (fileInputRef.current) {
//   fileInputRef.current.value = "";
// }

//       }
//       catch (error) {

//         console.log(
//           error
//         );

//         alert(
//           "Upload failed"
//         );

//       }
//       finally {

//         setUploading(
//           false
//         );

//       }

//     };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSendMessage();
//     }
//   };

//   // ── Typing emit ───────────────────────────────────────────────────────────

//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     setInput(value);
//     if (!selectedChat) return;

//     const socket = getSocket();
//     socket.emit("typing", { chatId: selectedChat._id, isTyping: value.length > 0 });

//     clearTimeout(typingTimeoutRef.current);
//     if (value.length > 0) {
//       typingTimeoutRef.current = setTimeout(() => {
//         socket.emit("typing", { chatId: selectedChat._id, isTyping: false });
//       }, 4000);
//     }
//   };

//   // ── Assign chat ───────────────────────────────────────────────────────────

//   // const handleAssign = async (chatId, e) => {
//   //   if (e) e.stopPropagation();
//   //   try {
//   //     const result = await supportChatServices.assignChat(chatId);
//   //     const updated = result.data;
//   //     setChats((prev) =>
//   //       prev.map((c) => (c._id === chatId ? { ...c, ...updated } : c))
//   //     );
//   //     if (selectedChat?._id === chatId) {
//   //       setSelectedChat((prev) => (prev ? { ...prev, ...updated } : null));
//   //     }
//   //   } catch {
//   //     alert("Assignment failed. Please try again.");
//   //   }
//   // };

//   const handleAssign = async (
//     chatId,
//     e
//   ) => {

//     if (e)
//       e.stopPropagation();

//     try {

//       const result =
//         await supportChatServices
//           .assignChat(
//             chatId
//           );

//       console.log(
//         "Assign API response:",
//         result
//       );

//       const updated =
//         result.data;

//       setChats(
//         (prev) =>

//           prev.map(
//             (c) =>

//               c._id ===
//                 chatId

//                 ? {

//                   ...c,

//                   ...updated,

//                 }

//                 : c
//           )
//       );

//       if (
//         selectedChat?._id ===
//         chatId
//       ) {

//         setSelectedChat(
//           (prev) =>

//             prev

//               ? {

//                 ...prev,

//                 ...updated,

//               }

//               : null
//         );
//       }

//     } catch (
//     error
//     ) {

//       console.error(
//         "Assign failed:",

//         error
//       );

//       alert(
//         "Assignment failed"
//       );

//     }

//   };

//   // ── Loading ───────────────────────────────────────────────────────────────

// if (reloading) return (
//   <Layout>
//     <div style={loaderStyles.overlay}>
//       <div style={loaderStyles.spinner} />
//       <p style={loaderStyles.text}>Setting up support chat...</p>
//     </div>
//   </Layout>
// );

// if (isLoading) return (
//   <Layout>
//     <div style={loaderStyles.overlay}>
//       <div style={loaderStyles.spinner} />
//       <p style={loaderStyles.text}>Loading chats...</p>
//     </div>
//   </Layout>
// );

//   // ── UI ────────────────────────────────────────────────────────────────────

//   return (
//     <Layout>
//           <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//       <div style={styles.container}>

//         {/* ── Sidebar ───────────────────────────────────────────────────── */}

//         <div style={styles.sidebar}>
//           <div style={styles.sidebarHeader}>
//             <h2 style={styles.sidebarTitle}>Support Chats</h2>
//             <span style={styles.badge}>{chats.length} Active</span>
//           </div>

//           <div style={styles.chatList}>
//             {chats.map((chat) => {
//               const isSelected = selectedChat?._id === chat._id;
//               const isOnline = onlineUsers[chat.participant1?._id] || false;
//               const assignedAdminId = getAssignedAdminId(chat);
//               const isAssignedToMe = assignedAdminId === currentAdminId;

//               // console.log({

//               //   assignedAdminId,

//               //   currentAdminId,

//               //   equal:

//               //     assignedAdminId ===
//               //     currentAdminId

//               // });
//               const unread = chat.unreadCount?.[currentAdminId] || 0;

//               return (
//                 <div
//                   key={chat._id}
//                   onClick={() => handleSelectChat(chat)}
//                   style={{
//                     ...styles.chatItem,
//                     ...(isSelected ? styles.chatItemActive : {}),
//                   }}
//                 >
//                   {/* Avatar */}
//                   <div
//                     style={
//                       styles.avatarWrap
//                     }
//                   >

//                     {

//                       !imageLoaded[
//                       chat._id
//                       ]

//                       &&

//                       (

//                         <div

//                           style={

//                             styles
//                               .avatarPlaceholder

//                           }

//                         >

//                           👤

//                         </div>

//                       )

//                     }


//                     {

//                       chat.participant1
//                         ?.profilePhoto

//                       &&

//                       <img

//                         src={
//                           chat.participant1
//                             .profilePhoto
//                         }

//                         alt=
//                         "avatar"

//                         style={{

//                           ...styles
//                             .avatar,

//                           display:

//                             imageLoaded[
//                               chat._id
//                             ]

//                               ?

//                               "block"

//                               :

//                               "none"

//                         }}

//                         onLoad={() => {

//                           setImageLoaded(
//                             prev =>
//                             ({

//                               ...prev,

//                               [chat._id]:

//                                 true

//                             })
//                           );

//                         }}

//                         onError={() => {

//                           setImageLoaded(
//                             prev =>
//                             ({

//                               ...prev,

//                               [chat._id]:

//                                 false

//                             })
//                           );

//                         }}

//                       />

//                     }


//                     <span

//                       style={{

//                         ...styles
//                           .onlineDot,

//                         backgroundColor:

//                           isOnline

//                             ?

//                             "#10b981"

//                             :

//                             "#9ca3af"

//                       }}

//                     />

//                   </div>

//                   {/* Info */}
//                   <div style={styles.chatInfo}>
//                     <div style={styles.chatInfoRow}>
//                       <span style={styles.clientName}>{getClientName(chat)}</span>
//                       {unread > 0 && (
//                         <span style={styles.unreadBadge}>{unread}</span>
//                       )}
//                     </div>

//                     <span style={styles.lastMsg}>
//   <span style={{
//     ...styles.lastMsg,
//     ...(chat.lastMessage?.mediaUrl || chat.lastMessage?.content
//       ? {
//           color: "#111827",
//           fontWeight: 600,
//           backgroundColor: "#eff6ff",
//           borderRadius: "4px",
//           padding: "1px 5px",
//         }
//       : {
//           color: "#9ca3af",
//           fontStyle: "italic",
//           fontWeight: 400,
//         }
//     )
//   }}>
//     {
//       chat.lastMessage?.mediaUrl
//         ? "📎 File"
//         : chat.lastMessage?.content
//         || "No new messages"
//     }
//   </span>
// </span>

//                     <div style={styles.tagsRow}>
//                       <span style={styles.tag}>
//                         {chat.participant1Type === "seller" ? "Seller" : "Customer"}
//                       </span>
//                       {/* {isAssignedToMe ? (
//                         <span style={{ ...styles.tag, ...styles.tagBlue }}>Assigned to You</span>
//                       ) : assignedAdminId ? (
//                         <span style={{ ...styles.tag, ...styles.tagGray }}>Assigned (Other)</span>
//                       ) : (
//                         <span style={{ ...styles.tag, ...styles.tagAmber }}>Unassigned</span>
//                       )} */}
//                     </div>

//                     {/* <button
//                       onClick={(e) => handleAssign(chat._id, e)}
//                       style={styles.assignBtn}
//                     >
//                       {isAssignedToMe ? "Reassign to Me" : "Assign to Me"}
//                     </button> */}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         {/* ── Chat Window ───────────────────────────────────────────────── */}

//         <div style={styles.chatArea}>
//           {selectedChat ? (
//             <>
//               {/* Header */}
//               <div style={styles.chatHeader}>
//                 <div>
//                   <div style={styles.chatHeaderName}>
//                     {getClientName(selectedChat)}
//                   </div>
//                   <div style={styles.chatHeaderMeta}>
//                     {[
//                       selectedChat.participant1?.email,
//                       selectedChat.participant1?.phoneNumber,
//                     ]
//                       .filter(Boolean)
//                       .join(" · ")}{" "}
//                     {selectedChat.participant1Type
//                       ? `· ${selectedChat.participant1Type.toUpperCase()}`
//                       : ""}
//                   </div>
//                 </div>
//                 {/* {!getAssignedAdminId(selectedChat) && (
//                   <button style={styles.primaryBtn} onClick={() => handleAssign(selectedChat._id)}>
//                     Assign to Me
//                   </button>
//                 )} */}
//                 {/* {getAssignedAdminId(selectedChat) &&
//                   getAssignedAdminId(selectedChat) !== currentAdminId && (
//                     <button style={styles.secondaryBtn} onClick={() => handleAssign(selectedChat._id)}>
//                       Reassign to Me
//                     </button>
//                   )} */}
//               </div>

//               {/* Messages */}
//               <div style={styles.messagesArea}>
//                 {messages.length === 0 ? (
//                   <div style={styles.emptyMessages}>No messages yet</div>
//                 ) : (
//                   messages.map((msg) => {
//                     const isAdmin = msg.senderType === "admin";
//                     return (
//                       <div
//                         key={msg._id}
//                         style={{
//                           ...styles.messageRow,
//                           justifyContent: isAdmin ? "flex-end" : "flex-start",
//                         }}
//                       >
//                         <div
//                           style={{
//                             ...styles.bubble,
//                             backgroundColor: isAdmin ? "#2563eb" : "#f3f4f6",
//                             color: isAdmin ? "#ffffff" : "#1f2937",
//                           }}
//                         >
//                           <>

//                             {msg.mediaUrl &&
//                               msg.mediaType === "image" && (

//                                 <img
//                                   src={msg.mediaUrl}
//                                   alt="chat-media"
//                                   style={{
//                                     maxWidth: "220px",
//                                     borderRadius: "8px",
//                                     marginBottom: "8px",
//                                     cursor: "pointer",
//                                   }}

//                                   onClick={() => {

//                                     setSelectedImage(

//                                       msg.mediaUrl

//                                     );

//                                   }}
//                                 />

//                               )}



//                             {msg.mediaUrl &&
//                               msg.mediaType === "video" && (

//                                 <video
//                                   controls
//                                   style={{
//                                     maxWidth: "220px",
//                                     borderRadius: "8px",
//                                     marginBottom: "8px",
//                                   }}
//                                 >

//                                   <source
//                                     src={msg.mediaUrl}
//                                   />

//                                 </video>

//                               )}


//                             {msg.mediaUrl &&
//                               msg.mediaType === "audio" && (

//                                 <audio
//                                   controls
//                                   src={msg.mediaUrl}
//                                 />

//                               )}


//                             {

//                               msg.mediaUrl &&

//                               msg.mediaType ===

//                               "document"

//                               &&

//                               (

//                                 <a

//                                   href={
//                                     msg.mediaUrl
//                                   }

//                                   target=
//                                   "_blank"

//                                   rel=
//                                   "noreferrer"

//                                   style={{

//                                     display:
//                                       "inline-flex",

//                                     alignItems:
//                                       "center",

//                                     gap:
//                                       "6px"

//                                   }}

//                                 >

//                                   📄

//                                   {

//                                     decodeURIComponent(

//                                       msg.mediaUrl

//                                         .split("/")

//                                         .pop()

//                                     )

//                                       .split(".")

//                                       .slice(0, -1)

//                                       .join(".")

//                                   }

//                                 </a>

//                               )

//                             }


//                             {msg.content && (

//                               <p
//                                 style={styles.bubbleText}
//                               >

//                                 {msg.content}

//                               </p>

//                             )}

//                           </>
//                           <span

//                             style={{

//                               ...styles.bubbleTime,

//                               color:

//                                 isAdmin

//                                   ?

//                                   "#93c5fd"

//                                   :

//                                   "#6b7280"

//                             }}

//                           >

//                             {

//                               new Date(

//                                 msg.createdAt

//                               )

//                                 .toLocaleTimeString(

//                                   [],

//                                   {

//                                     hour:
//                                       "2-digit",

//                                     minute:
//                                       "2-digit"

//                                   }

//                                 )

//                             }


//                             {

//                               isAdmin && (

//                                 <span

//                                   style={{

//                                     marginLeft:

//                                       6,

//                                     color:

//                                       msg.markAsRead

//                                         ?

//                                         "#3b82f6"

//                                         :

//                                         "#9ca3af"

//                                   }}

//                                 >

//                                   {

//                                     msg.markAsRead

//                                       ?

//                                       "✓✓"

//                                       :

//                                       "✓"

//                                   }

//                                 </span>

//                               )

//                             }

//                           </span>
//                         </div>
//                       </div>
//                     );
//                   })
//                 )}

//                 {isUserTyping && (
//                   <div style={{ ...styles.messageRow, justifyContent: "flex-start" }}>
//                     <div style={styles.typingBubble}>User is typing...</div>
//                   </div>
//                 )}

//                 <div ref={messagesEndRef} />
//                 {

//                   selectedImage && (

//                     <div

//                       style={
//                         styles.imageModal
//                       }

//                       onClick={() => {

//                         setSelectedImage(
//                           null
//                         );

//                       }}

//                     >

//                       <button

//                         style={
//                           styles.closeBtn
//                         }

//                         onClick={() => {

//                           setSelectedImage(
//                             null
//                           );

//                         }}

//                       >

//                         ✕

//                       </button>


//                       <img

//                         src={
//                           selectedImage
//                         }

//                         alt=
//                         "preview"

//                         style={
//                           styles.enlargedImage
//                         }

//                       />

//                     </div>

//                   )

//                 }
//               </div>



//               {

//                 selectedFile && (

//                   <div

//                     style={
//                       styles.previewArea
//                     }

//                   >

//                     {/* IMAGE */}

//                     {

//                       selectedFile.type
//                         .startsWith(
//                           "image/"
//                         )

//                       &&

//                       <img

//                         src={

//                           URL.createObjectURL(
//                             selectedFile
//                           )

//                         }

//                         alt="preview"

//                         style={

//                           styles.previewImage

//                         }

//                       />

//                     }


//                     {/* VIDEO */}

//                     {

//                       selectedFile.type
//                         .startsWith(
//                           "video/"
//                         )

//                       &&

//                       <video

//                         controls

//                         src={

//                           URL.createObjectURL(
//                             selectedFile
//                           )

//                         }

//                         style={

//                           styles.previewVideo

//                         }

//                       />



//                     }


//                     {/* AUDIO */}

//                     {

//                       selectedFile.type
//                         .startsWith(
//                           "audio/"
//                         )

//                       &&

//                       <audio

//                         controls

//                         src={

//                           URL.createObjectURL(
//                             selectedFile
//                           )

//                         }

//                       />

//                     }


//                     {/* DOCUMENT */}

//                     {

//                       !selectedFile.type
//                         .startsWith(
//                           "image/"
//                         )

//                       &&

//                       !selectedFile.type
//                         .startsWith(
//                           "video/"
//                         )

//                       &&

//                       !selectedFile.type
//                         .startsWith(
//                           "audio/"
//                         )

//                       &&

//                       <div>

//                         📄

//                         {

//                           selectedFile.name

//                         }

//                       </div>

//                     }


//                     <button

//                     onClick={() => {
//   setSelectedFile(null);

//   if (fileInputRef.current) {
//     fileInputRef.current.value = "";
//   }
// }}

//                       style={

//                         styles.removePreview

//                       }

//                     >

//                       ✕

//                     </button>

//                   </div>

//                 )

//               }

//               {/* Input */}
//               <div style={styles.inputArea}>

//                 <label
//                   htmlFor="fileUpload"
//                   style={styles.fileButton}
//                 >

//                   📎

//                 </label>

//                 <input
//                   ref={fileInputRef}
//                   id="fileUpload"
//                   type="file"
//                   accept="
//   image/*,
//   audio/*,
//   .pdf,
//   .doc,
//   .docx"

//                   style={{
//                     display: "none"
//                   }}

//                   onChange={(e) => {

//                     setSelectedFile(
//                       e.target.files[0]
//                     );

//                   }}
//                 />


//                 {selectedFile && (

//                   <span
//                     style={
//                       styles.selectedFile
//                     }
//                   >

//                     {selectedFile.name}

//                   </span>

//                 )}


//                 <input
//                   value={input}

//                   onChange={
//                     handleInputChange
//                   }

//                   onKeyDown={
//                     handleKeyDown
//                   }

//                   placeholder=
//                   "Type a message..."

//                   style={
//                     styles.textInput
//                   }
//                 />


//                 <button

//                   onClick={
//                     handleSendMessage
//                   }

//                   style={
//                     styles.sendBtn
//                   }

//                   disabled={
//                     uploading
//                   }

//                 >

//                   {

//                     uploading

//                       ?

//                       "⏳"

//                       :

//                       "➤"

//                   }

//                 </button>

//               </div>
//             </>
//           ) : (
//             <div style={styles.emptyState}>

//               <svg

//                 style={{

//                   width:
//                     80,

//                   height:
//                     80,

//                   color:
//                     "#9ca3af",

//                   marginBottom:
//                     20

//                 }}

//                 fill="none"

//                 stroke=
//                 "currentColor"

//                 viewBox=
//                 "0 0 24 24"

//               >

//                 <path

//                   strokeLinecap=
//                   "round"

//                   strokeLinejoin=
//                   "round"

//                   strokeWidth=
//                   "1.5"

//                   d=
//                   "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"

//                 />

//               </svg>


//               <p

//                 style={{

//                   color:
//                     "#6b7280",

//                   fontSize:
//                     18,

//                   margin:
//                     0,

//                   fontWeight:
//                     500

//                 }}

//               >

//                 Select a chat from the sidebar to begin

//               </p>

//             </div>
//           )}
//         </div>
//       </div>
//     </Layout>
//   );
// };

// // ─── Styles ────────────────────────────────────────────────────────────────

// // ADD THIS above const styles = { ... }:
// const loaderStyles = {
//   overlay: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "85vh",
//     width: "100%",
//     backgroundColor: "#ffffff",
//     borderRadius: "12px",
//     border: "1px solid #e5e7eb",
//     boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
//     gap: "16px",
//   },
//   spinner: {
//     width: "44px",
//     height: "44px",
//     border: "4px solid #e5e7eb",
//     borderTop: "4px solid #2563eb",
//     borderRadius: "50%",
//     animation: "spin 0.8s linear infinite",
//   },
//   text: {
//     color: "#6b7280",
//     fontSize: "14px",
//     fontWeight: 500,
//     margin: 0,
//   },
// };

// const styles = {
//   container: {
//     display: "flex",
//     height: "85vh",
//     border: "1px solid #e5e7eb",
//     borderRadius: "12px",
//     overflow: "hidden",
//     backgroundColor: "#ffffff",
//     boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
//   },
//   sidebar: {
//     width: "320px",
//     flexShrink: 0,
//     borderRight: "1px solid #e5e7eb",
//     display: "flex",
//     flexDirection: "column",
//     backgroundColor: "#f9fafb",
//   },
//   sidebarHeader: {
//     padding: "16px 20px",
//     borderBottom: "1px solid #e5e7eb",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   sidebarTitle: { margin: 0, fontSize: 17, fontWeight: 600, color: "#111827" },
//   badge: {
//     backgroundColor: "#eff6ff",
//     color: "#2563eb",
//     padding: "3px 10px",
//     borderRadius: 12,
//     fontSize: 12,
//     fontWeight: 500,
//   },
//   chatList: { flex: 1, overflowY: "auto", padding: "10px" },
//   chatItem: {
//     display: "flex",
//     gap: 10,
//     padding: "10px",
//     borderRadius: 10,
//     cursor: "pointer",
//     marginBottom: 6,
//     border: "1px solid transparent",
//   },
//   chatItemActive: { backgroundColor: "#eff6ff", border: "1px solid #bfdbfe" },
//   avatarWrap: { position: "relative", flexShrink: 0, alignSelf: "flex-start", marginTop: 2 },
//   avatar: { width: 42, height: 42, borderRadius: "50%", objectFit: "cover" },
//   avatarPlaceholder: {
//     width: 42, height: 42, borderRadius: "50%",
//     backgroundColor: "#e5e7eb", color: "#374151",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     fontWeight: 700, fontSize: 16,
//   },
//   onlineDot: {
//     position: "absolute", bottom: 1, right: 1,
//     width: 10, height: 10, borderRadius: "50%", border: "2px solid #f9fafb",
//   },
//   chatInfo: { flex: 1, minWidth: 0 },
//   chatInfoRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 },
//   clientName: { fontWeight: 600, fontSize: 14, color: "#1f2937" },
//   unreadBadge: {
//     backgroundColor: "#ef4444", color: "#fff", borderRadius: "50%",
//     minWidth: 18, height: 18, fontSize: 10, fontWeight: 700,
//     display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "0 4px",
//   },
//   lastMsg: {
//     display: "block", fontSize: 12, color: "#6b7280",
//     whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 5,
//   },
//   tagsRow: { display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 6 },
//   tag: {
//     fontSize: 10, padding: "2px 6px", borderRadius: 4,
//     fontWeight: 600, textTransform: "uppercase", backgroundColor: "#e5e7eb", color: "#374151",
//   },
//   tagBlue: { backgroundColor: "#dbeafe", color: "#1e40af" },
//   tagGray: { backgroundColor: "#f3f4f6", color: "#374151" },
//   tagAmber: { backgroundColor: "#fef3c7", color: "#92400e" },
//   assignBtn: {
//     fontSize: 11, padding: "3px 10px", border: "1px solid #d1d5db",
//     borderRadius: 5, backgroundColor: "#fff", cursor: "pointer", color: "#374151", fontWeight: 500,
//   },
//   chatArea: {

//     flex: 1,

//     display: "flex",

//     flexDirection: "column",

//     overflow: "hidden",

//     height: "100%"

//   },
//   chatHeader: {
//     padding: "14px 20px", borderBottom: "1px solid #e5e7eb",
//     display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0,
//   },
//   chatHeaderName: { fontWeight: 600, fontSize: 15, color: "#111827", marginBottom: 2 },
//   chatHeaderMeta: { fontSize: 12, color: "#6b7280" },
//   primaryBtn: {
//     backgroundColor: "#2563eb", color: "#fff", border: "none",
//     borderRadius: 7, padding: "8px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer",
//   },
//   secondaryBtn: {
//     backgroundColor: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe",
//     borderRadius: 7, padding: "8px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer",
//   },
//   messagesArea: { flex: 1, overflowY: "auto", padding: "20px", backgroundColor: "#f9fafb" },
//   emptyMessages: { textAlign: "center", color: "#9ca3af", fontSize: 13, marginTop: 40 },
//   messageRow: { display: "flex", marginBottom: 12 },
//   bubble: { maxWidth: "70%", padding: "10px 14px", borderRadius: 14, boxShadow: "0 1px 2px rgba(0,0,0,0.05)" },
//   bubbleText: { margin: 0, fontSize: 14, lineHeight: "1.5", wordBreak: "break-word" },
//   bubbleTime: { display: "block", fontSize: 10, textAlign: "right", marginTop: 4 },
//   typingBubble: {
//     padding: "8px 14px", borderRadius: 12, backgroundColor: "#f3f4f6",
//     color: "#4b5563", fontSize: 12, fontStyle: "italic",
//   },
//   inputArea: {
//     display: "flex",

//     alignItems: "center",

//     gap: "10px",

//     padding: "14px",

//     background: "#fff",

//     borderTop:
//       "1px solid #e5e7eb"
//   },
//   textInput: {

//     flex: 1,

//     height: "46px",

//     padding:
//       "0 16px",

//     borderRadius:
//       "25px",

//     border:
//       "1px solid #ddd",

//     fontSize:
//       "14px",

//     outline:
//       "none",

//     background:
//       "#f9fafb"

//   },
//   sendBtn: {

//     width: "46px",

//     height: "46px",

//     borderRadius:
//       "50%",

//     border:
//       "none",

//     background:
//       "#2563eb",

//     color:
//       "white",

//     fontSize:
//       "20px",

//     cursor:
//       "pointer",

//     display:
//       "flex",

//     alignItems:
//       "center",

//     justifyContent:
//       "center",

//     transition:
//       "0.2s"

//   },
//   fileButton: {

//     width: "42px",

//     height: "42px",

//     borderRadius:
//       "50%",

//     background:
//       "#f3f4f6",

//     display:
//       "flex",

//     alignItems:
//       "center",

//     justifyContent:
//       "center",

//     cursor:
//       "pointer",

//     fontSize:
//       "20px",

//     flexShrink:
//       0

//   },

//   selectedFile: {

//     fontSize:
//       "12px",

//     color:
//       "#6b7280",

//     maxWidth:
//       "100px",

//     overflow:
//       "hidden",

//     textOverflow:
//       "ellipsis",

//     whiteSpace:
//       "nowrap"

//   },

//   previewArea: {

//     padding:
//       "12px",

//     background:
//       "#f9fafb",

//     borderTop:
//       "1px solid #e5e7eb",

//     display:
//       "flex",

//     alignItems:
//       "center",

//     gap:
//       "10px",

//     position:
//       "relative"

//   },

//   previewImage: {

//     maxWidth:
//       "120px",

//     maxHeight:
//       "120px",

//     borderRadius:
//       "8px",

//     objectFit:
//       "cover"

//   },

//   previewVideo: {

//     maxWidth:
//       "150px",

//     borderRadius:
//       "8px"

//   },

//   removePreview: {

//     position:
//       "absolute",

//     top:
//       "8px",

//     right:
//       "8px",

//     width:
//       "28px",

//     height:
//       "28px",

//     border:
//       "none",

//     borderRadius:
//       "50%",

//     background:
//       "#ef4444",

//     color:
//       "white",

//     cursor:
//       "pointer"

//   },

//   emptyState: {

//     flex: 1,

//     display: "flex",

//     flexDirection: "column",

//     justifyContent: "center",

//     alignItems: "center",

//     textAlign: "center",

//     height: "100%",

//     width: "100%",

//     minHeight: "100%",

//     background: "#fff",

//   },

//   imageModal: {

//     position:
//       "fixed",

//     top: 0,

//     left: 0,

//     width:
//       "100vw",

//     height:
//       "100vh",

//     background:
//       "rgba(0,0,0,.85)",

//     display:
//       "flex",

//     justifyContent:
//       "center",

//     alignItems:
//       "center",

//     zIndex:
//       9999

//   },

//   enlargedImage: {

//     maxWidth:
//       "90%",

//     maxHeight:
//       "90%",

//     borderRadius:
//       "12px",

//     objectFit:
//       "contain"

//   },

//   closeBtn: {

//     position:
//       "absolute",

//     top:
//       20,

//     right:
//       20,

//     background:
//       "transparent",

//     border:
//       "none",

//     fontSize:
//       30,

//     color:
//       "#fff",

//     cursor:
//       "pointer"

//   },
// };

// export default SupportChat;


import Layout from "components/ui/Layout";
import { useSupportChats } from "features/supportChat/hooks/useSupportChats";
import { supportChatServices } from "features/supportChat/services/supportChat.service";
import { connectSocket, getSocket, disconnectSocket } from "features/supportChat/socket/socket";
import Cookies from "js-cookie";
import { useEffect, useState, useRef, useCallback } from "react";
import { useAuth } from "../../contexts/AuthContext";

const SupportChat = () => {
  const { user } = useAuth();
  const currentAdminId = user?._id;
  const { data, isLoading } = useSupportChats();

  // ── State ─────────────────────────────────────────────────────────────────
  const [chats, setChats] = useState([]);
  const [reloading, setReloading] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [input, setInput] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [isUserTyping, setIsUserTyping] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState({});
  const [imageLoaded, setImageLoaded] = useState({});

  // ── Refs ──────────────────────────────────────────────────────────────────
  const messagesEndRef = useRef(null);
  const typingTimeoutRef = useRef(null);
  const currentRoomRef = useRef(null);
  const selectedChatRef = useRef(null);
  const fileInputRef = useRef(null);
  // Track which chats are already assigned to avoid redundant assign calls
  const assignedChatsRef = useRef(new Set());
  selectedChatRef.current = selectedChat;

  // ── Sync chats list from query ─────────────────────────────────────────────
  useEffect(() => {
    if (data?.data) {
      setChats(data.data);
      // Pre-populate assigned set from initial data
      data.data.forEach((chat) => {
        const assignedId =
          typeof chat.participant2 === "string"
            ? chat.participant2
            : chat.participant2?._id;
        if (assignedId === currentAdminId) {
          assignedChatsRef.current.add(chat._id);
        }
      });
    }
  }, [data, currentAdminId]);

  useEffect(() => {
    if (messages.length > 0) {
      scrollToBottom("instant");
    }
  }, [messages.length]);

  // ── Helpers ───────────────────────────────────────────────────────────────
  const scrollToBottom = (behavior = "smooth") => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior });
    }, 80);
  };

  const getClientName = (chat) => {
    const p = chat?.participant1;
    if (!p) return "Unknown";
    const name = [p.firstName, p.lastName].filter(Boolean).join(" ");
    return name || p.phoneNumber || p.email || "Unknown";
  };

  const getClientInitial = (chat) => {
    const p = chat?.participant1;
    if (!p) return "U";
    return p.firstName?.[0] || p.phoneNumber?.[0] || "U";
  };

  const getAssignedAdminId = (chat) => {
    if (!chat?.participant2) return null;
    return typeof chat.participant2 === "string"
      ? chat.participant2
      : chat.participant2._id;
  };

  const getMediaType = (file) => {
    if (file.type.startsWith("image/")) return "image";
    if (file.type.startsWith("video/")) return "video";
    if (file.type.startsWith("audio/")) return "audio";
    return "document";
  };

  useEffect(() => {
    const hasReloaded = sessionStorage.getItem("supportChatReloaded");
    if (!hasReloaded) {
      setReloading(true);
      sessionStorage.setItem("supportChatReloaded", "true");
      const t = setTimeout(() => {
        window.location.reload();
      }, 100);
      return () => clearTimeout(t);
    }
    return () => {
      sessionStorage.removeItem("supportChatReloaded");
    };
  }, []);

  // ── Connect socket ONCE on mount — all listeners registered here ───────────
  useEffect(() => {
    const token = Cookies.get("accessToken");
    if (!token) {
      console.warn("No access token found — skipping socket connection");
      return;
    }
    const socket = connectSocket(token);

    socket.on("allMessages", (payload) => {
      setMessages(
        (payload.messages || []).map((msg) => ({
          ...msg,
          markAsRead: msg.markAsRead ?? msg.isRead ?? false,
        }))
      );
      scrollToBottom("instant");
    });

    socket.on("newMessage", (message) => {
      const activeRoom = currentRoomRef.current;

      setChats((prev) =>
        prev.map((chat) => {
          if (chat._id !== message.chatId) return chat;
          const isActiveRoom = activeRoom === message.chatId;
          const prevUnread = chat.unreadCount?.[currentAdminId] || 0;
          const isUnread =
            message.isRead === false &&
            !isActiveRoom &&
            message.senderType !== "admin";
          return {
            ...chat,
            lastMessage: message,
            unreadCount: {
              ...chat.unreadCount,
              [currentAdminId]: isUnread
                ? prevUnread + 1
                : isActiveRoom
                ? 0
                : prevUnread,
            },
          };
        })
      );

      if (activeRoom === message.chatId) {
        setMessages((prev) => {
          const exists = prev.some((m) => m._id === message._id);
          if (exists) return prev;
          return [
            ...prev,
            {
              ...message,
              markAsRead: message.markAsRead ?? message.isRead ?? false,
            },
          ];
        });
        scrollToBottom();
        socket.emit("markMessagesRead", { chatId: message.chatId });
        setChats((prev) =>
          prev.map((c) =>
            c._id === message.chatId
              ? { ...c, unreadCount: { ...c.unreadCount, [currentAdminId]: 0 } }
              : c
          )
        );
      }
    });

    socket.on("userStatus", (data) => {
      setOnlineUsers((prev) => ({ ...prev, [data.userId]: data.isOnline }));
    });

    socket.on("typing", (data) => {
      const activeChat = selectedChatRef.current;
      const clientId = activeChat?.participant1?._id;
      const activeChatId = activeChat?._id;
      if (data.userId === clientId && data.chatId === activeChatId) {
        setIsUserTyping(data.isTyping);
      } else if (data.chatId !== activeChatId) {
        setIsUserTyping(false);
      }
    });

    socket.on("messagesRead", (data) => {
      setChats((prev) =>
        prev.map((chat) =>
          chat._id === data.chatId
            ? {
                ...chat,
                unreadCount: { ...chat.unreadCount, [currentAdminId]: 0 },
              }
            : chat
        )
      );
    });

    socket.on("totalUnreadCount", (data) => {
      if (data?.chatId && typeof data?.count === "number") {
        setChats((prev) =>
          prev.map((chat) =>
            chat._id === data.chatId
              ? {
                  ...chat,
                  unreadCount: {
                    ...chat.unreadCount,
                    [currentAdminId]: isNaN(data.count) ? 0 : data.count,
                  },
                }
              : chat
          )
        );
      }
    });

    socket.on("messageSeen", (data) => {
      if (data.chatId && data.chatId !== currentRoomRef.current) return;
      setMessages((prev) =>
        prev.map((msg) =>
          data.messageIds?.includes(msg._id) ? { ...msg, markAsRead: true } : msg
        )
      );
    });

    return () => {
      socket.off("allMessages");
      socket.off("newMessage");
      socket.off("userStatus");
      socket.off("typing");
      socket.off("messagesRead");
      socket.off("totalUnreadCount");
      socket.off("messageSeen");
      currentRoomRef.current = null;
      disconnectSocket();
    };
  }, [currentAdminId]);

  // ── Select a chat room ────────────────────────────────────────────────────
  // FIX: await handleAssign before emitting joinChat so the server has the
  // assignment committed before it processes the joinChat event.
  // Skip the assign call entirely for chats already assigned to this admin
  // to avoid an unnecessary round-trip on every click.
  const handleSelectChat = useCallback(
    async (chat) => {
      const socket = getSocket();
      if (!socket) return;

      // Leave old room
      if (currentRoomRef.current && currentRoomRef.current !== chat._id) {
        socket.emit("leaveChat", { chatId: currentRoomRef.current });
      }

      // Optimistic UI updates — do these immediately so the sidebar feels snappy
      currentRoomRef.current = chat._id;
      setSelectedChat(chat);
      setMessages([]);
      setInput("");
      setIsUserTyping(false);
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = null;
      }
      setChats((prev) =>
        prev.map((c) =>
          c._id === chat._id
            ? { ...c, unreadCount: { ...c.unreadCount, [currentAdminId]: 0 } }
            : c
        )
      );
      scrollToBottom("instant");

      // Only assign if not already assigned to this admin
      const alreadyAssigned = assignedChatsRef.current.has(chat._id);
      if (!alreadyAssigned) {
        try {
          const result = await supportChatServices.assignChat(chat._id);
          const updated = result.data;

          // Mark as assigned so subsequent clicks skip this
          assignedChatsRef.current.add(chat._id);

          setChats((prev) =>
            prev.map((c) => (c._id === chat._id ? { ...c, ...updated } : c))
          );
          // Keep selectedChat in sync if the user hasn't navigated away
          setSelectedChat((prev) =>
            prev?._id === chat._id ? { ...prev, ...updated } : prev
          );
        } catch (error) {
          console.error("Assign failed:", error);
          // Non-fatal: still proceed to join the chat room below
        }
      }

      // Emit joinChat AFTER assignment is confirmed (or skipped)
      // This is the core fix — previously joinChat fired before assignChat resolved
      socket.emit("joinChat", { chatId: chat._id });
      socket.emit("markMessagesRead", { chatId: chat._id });
    },
    [currentAdminId]
  );

  // ── Send message ──────────────────────────────────────────────────────────
  const handleSendMessage = async () => {
    if (!selectedChat || (!input.trim() && !selectedFile)) return;

    const socket = getSocket();
    let mediaUrl = null;
    let mediaType = null;

    try {
      setUploading(true);

      if (selectedFile) {
        const uploadResponse = await supportChatServices.uploadSupportFile(selectedFile);
        mediaUrl = uploadResponse.data.key;
        mediaType = getMediaType(selectedFile);
      }

      socket.emit("sendMessage", {
        chatId: selectedChat._id,
        content: input.trim(),
        mediaUrl,
        mediaType,
        markAsRead: false,
      });

      socket.emit("typing", { chatId: selectedChat._id, isTyping: false });

      setInput("");
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (error) {
      console.log(error);
      alert("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  // ── Typing emit ───────────────────────────────────────────────────────────
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);
    if (!selectedChat) return;

    const socket = getSocket();
    socket.emit("typing", { chatId: selectedChat._id, isTyping: value.length > 0 });

    clearTimeout(typingTimeoutRef.current);
    if (value.length > 0) {
      typingTimeoutRef.current = setTimeout(() => {
        socket.emit("typing", { chatId: selectedChat._id, isTyping: false });
      }, 4000);
    }
  };

  // ── Loading ───────────────────────────────────────────────────────────────
  if (reloading)
    return (
      <Layout>
        <div style={loaderStyles.overlay}>
          <div style={loaderStyles.spinner} />
          <p style={loaderStyles.text}>Setting up support chat...</p>
        </div>
      </Layout>
    );

  if (isLoading)
    return (
      <Layout>
        <div style={loaderStyles.overlay}>
          <div style={loaderStyles.spinner} />
          <p style={loaderStyles.text}>Loading chats...</p>
        </div>
      </Layout>
    );

  // ── UI ────────────────────────────────────────────────────────────────────
  return (
    <Layout>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={styles.container}>
        {/* ── Sidebar ─────────────────────────────────────────────────── */}
        <div style={styles.sidebar}>
          <div style={styles.sidebarHeader}>
            <h2 style={styles.sidebarTitle}>Support Chats</h2>
            <span style={styles.badge}>{chats.length} Active</span>
          </div>

          <div style={styles.chatList}>
            {chats.map((chat) => {
              const isSelected = selectedChat?._id === chat._id;
              const isOnline = onlineUsers[chat.participant1?._id] || false;
              const unread = chat.unreadCount?.[currentAdminId] || 0;

              return (
                <div
                  key={chat._id}
                  onClick={() => handleSelectChat(chat)}
                  style={{
                    ...styles.chatItem,
                    ...(isSelected ? styles.chatItemActive : {}),
                  }}
                >
                  {/* Avatar */}
                  <div style={styles.avatarWrap}>
                    {!imageLoaded[chat._id] && (
                      <div style={styles.avatarPlaceholder}>👤</div>
                    )}
                    {chat.participant1?.profilePhoto && (
                      <img
                        src={chat.participant1.profilePhoto}
                        alt="avatar"
                        style={{
                          ...styles.avatar,
                          display: imageLoaded[chat._id] ? "block" : "none",
                        }}
                        onLoad={() =>
                          setImageLoaded((prev) => ({ ...prev, [chat._id]: true }))
                        }
                        onError={() =>
                          setImageLoaded((prev) => ({ ...prev, [chat._id]: false }))
                        }
                      />
                    )}
                    <span
                      style={{
                        ...styles.onlineDot,
                        backgroundColor: isOnline ? "#10b981" : "#9ca3af",
                      }}
                    />
                  </div>

                  {/* Info */}
                  <div style={styles.chatInfo}>
                    <div style={styles.chatInfoRow}>
                      <span style={styles.clientName}>{getClientName(chat)}</span>
                      {unread > 0 && (
                        <span style={styles.unreadBadge}>{unread}</span>
                      )}
                    </div>

                    <span style={styles.lastMsg}>
                      <span
                        style={{
                          ...styles.lastMsg,
                          ...(chat.lastMessage?.mediaUrl || chat.lastMessage?.content
                            ? {
                                color: "#111827",
                                fontWeight: 600,
                                backgroundColor: "#eff6ff",
                                borderRadius: "4px",
                                padding: "1px 5px",
                              }
                            : {
                                color: "#9ca3af",
                                fontStyle: "italic",
                                fontWeight: 400,
                              }),
                        }}
                      >
                        {chat.lastMessage?.mediaUrl
                          ? "📎 File"
                          : chat.lastMessage?.content || "No new messages"}
                      </span>
                    </span>

                    <div style={styles.tagsRow}>
                      <span style={styles.tag}>
                        {chat.participant1Type === "seller" ? "Seller" : "Customer"}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ── Chat Window ───────────────────────────────────────────────── */}
        <div style={styles.chatArea}>
          {selectedChat ? (
            <>
              {/* Header */}
              <div style={styles.chatHeader}>
                <div>
                  <div style={styles.chatHeaderName}>
                    {getClientName(selectedChat)}
                  </div>
                  <div style={styles.chatHeaderMeta}>
                    {[
                      selectedChat.participant1?.email,
                      selectedChat.participant1?.phoneNumber,
                    ]
                      .filter(Boolean)
                      .join(" · ")}{" "}
                    {selectedChat.participant1Type
                      ? `· ${selectedChat.participant1Type.toUpperCase()}`
                      : ""}
                  </div>
                </div>
              </div>

              {/* Messages */}
              <div style={styles.messagesArea}>
                {messages.length === 0 ? (
                  <div style={styles.emptyMessages}>No messages yet</div>
                ) : (
                  messages.map((msg) => {
                    const isAdmin = msg.senderType === "admin";
                    return (
                      <div
                        key={msg._id}
                        style={{
                          ...styles.messageRow,
                          justifyContent: isAdmin ? "flex-end" : "flex-start",
                        }}
                      >
                        <div
                          style={{
                            ...styles.bubble,
                            backgroundColor: isAdmin ? "#2563eb" : "#f3f4f6",
                            color: isAdmin ? "#ffffff" : "#1f2937",
                          }}
                        >
                          <>
                            {msg.mediaUrl && msg.mediaType === "image" && (
                              <img
                                src={msg.mediaUrl}
                                alt="chat-media"
                                style={{
                                  maxWidth: "220px",
                                  borderRadius: "8px",
                                  marginBottom: "8px",
                                  cursor: "pointer",
                                }}
                                onClick={() => setSelectedImage(msg.mediaUrl)}
                              />
                            )}

                            {msg.mediaUrl && msg.mediaType === "video" && (
                              <video
                                controls
                                style={{
                                  maxWidth: "220px",
                                  borderRadius: "8px",
                                  marginBottom: "8px",
                                }}
                              >
                                <source src={msg.mediaUrl} />
                              </video>
                            )}

                            {msg.mediaUrl && msg.mediaType === "audio" && (
                              <audio controls src={msg.mediaUrl} />
                            )}

                            {msg.mediaUrl && msg.mediaType === "document" && (
                              <a
                                href={msg.mediaUrl}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                📄{" "}
                                {decodeURIComponent(msg.mediaUrl.split("/").pop())
                                  .split(".")
                                  .slice(0, -1)
                                  .join(".")}
                              </a>
                            )}

                            {msg.content && (
                              <p style={styles.bubbleText}>{msg.content}</p>
                            )}
                          </>
                          <span
                            style={{
                              ...styles.bubbleTime,
                              color: isAdmin ? "#93c5fd" : "#6b7280",
                            }}
                          >
                            {new Date(msg.createdAt).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                            {isAdmin && (
                              <span
                                style={{
                                  marginLeft: 6,
                                  color: msg.markAsRead ? "#3b82f6" : "#9ca3af",
                                }}
                              >
                                {msg.markAsRead ? "✓✓" : "✓"}
                              </span>
                            )}
                          </span>
                        </div>
                      </div>
                    );
                  })
                )}

                {isUserTyping && (
                  <div
                    style={{ ...styles.messageRow, justifyContent: "flex-start" }}
                  >
                    <div style={styles.typingBubble}>User is typing...</div>
                  </div>
                )}

                <div ref={messagesEndRef} />

                {selectedImage && (
                  <div
                    style={styles.imageModal}
                    onClick={() => setSelectedImage(null)}
                  >
                    <button
                      style={styles.closeBtn}
                      onClick={() => setSelectedImage(null)}
                    >
                      ✕
                    </button>
                    <img
                      src={selectedImage}
                      alt="preview"
                      style={styles.enlargedImage}
                    />
                  </div>
                )}
              </div>

              {selectedFile && (
                <div style={styles.previewArea}>
                  {selectedFile.type.startsWith("image/") && (
                    <img
                      src={URL.createObjectURL(selectedFile)}
                      alt="preview"
                      style={styles.previewImage}
                    />
                  )}
                  {selectedFile.type.startsWith("video/") && (
                    <video
                      controls
                      src={URL.createObjectURL(selectedFile)}
                      style={styles.previewVideo}
                    />
                  )}
                  {selectedFile.type.startsWith("audio/") && (
                    <audio controls src={URL.createObjectURL(selectedFile)} />
                  )}
                  {!selectedFile.type.startsWith("image/") &&
                    !selectedFile.type.startsWith("video/") &&
                    !selectedFile.type.startsWith("audio/") && (
                      <div>📄 {selectedFile.name}</div>
                    )}
                  <button
                    onClick={() => {
                      setSelectedFile(null);
                      if (fileInputRef.current) fileInputRef.current.value = "";
                    }}
                    style={styles.removePreview}
                  >
                    ✕
                  </button>
                </div>
              )}

              {/* Input */}
              <div style={styles.inputArea}>
                <label htmlFor="fileUpload" style={styles.fileButton}>
                  📎
                </label>
                <input
                  ref={fileInputRef}
                  id="fileUpload"
                  type="file"
                  accept="image/*, audio/*, .pdf, .doc, .docx"
                  style={{ display: "none" }}
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
                {selectedFile && (
                  <span style={styles.selectedFile}>{selectedFile.name}</span>
                )}
                <input
                  value={input}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  placeholder="Type a message..."
                  style={styles.textInput}
                />
                <button
                  onClick={handleSendMessage}
                  style={styles.sendBtn}
                  disabled={uploading}
                >
                  {uploading ? "⏳" : "➤"}
                </button>
              </div>
            </>
          ) : (
            <div style={styles.emptyState}>
              <svg
                style={{
                  width: 80,
                  height: 80,
                  color: "#9ca3af",
                  marginBottom: 20,
                }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: 18,
                  margin: 0,
                  fontWeight: 500,
                }}
              >
                Select a chat from the sidebar to begin
              </p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────────
const loaderStyles = {
  overlay: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "85vh",
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    gap: "16px",
  },
  spinner: {
    width: "44px",
    height: "44px",
    border: "4px solid #e5e7eb",
    borderTop: "4px solid #2563eb",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  text: {
    color: "#6b7280",
    fontSize: "14px",
    fontWeight: 500,
    margin: 0,
  },
};

const styles = {
  container: {
    display: "flex",
    height: "85vh",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  },
  sidebar: {
    width: "320px",
    flexShrink: 0,
    borderRight: "1px solid #e5e7eb",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f9fafb",
  },
  sidebarHeader: {
    padding: "16px 20px",
    borderBottom: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sidebarTitle: { margin: 0, fontSize: 17, fontWeight: 600, color: "#111827" },
  badge: {
    backgroundColor: "#eff6ff",
    color: "#2563eb",
    padding: "3px 10px",
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 500,
  },
  chatList: { flex: 1, overflowY: "auto", padding: "10px" },
  chatItem: {
    display: "flex",
    gap: 10,
    padding: "10px",
    borderRadius: 10,
    cursor: "pointer",
    marginBottom: 6,
    border: "1px solid transparent",
  },
  chatItemActive: { backgroundColor: "#eff6ff", border: "1px solid #bfdbfe" },
  avatarWrap: {
    position: "relative",
    flexShrink: 0,
    alignSelf: "flex-start",
    marginTop: 2,
  },
  avatar: { width: 42, height: 42, borderRadius: "50%", objectFit: "cover" },
  avatarPlaceholder: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    backgroundColor: "#e5e7eb",
    color: "#374151",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 16,
  },
  onlineDot: {
    position: "absolute",
    bottom: 1,
    right: 1,
    width: 10,
    height: 10,
    borderRadius: "50%",
    border: "2px solid #f9fafb",
  },
  chatInfo: { flex: 1, minWidth: 0 },
  chatInfoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 3,
  },
  clientName: { fontWeight: 600, fontSize: 14, color: "#1f2937" },
  unreadBadge: {
    backgroundColor: "#ef4444",
    color: "#fff",
    borderRadius: "50%",
    minWidth: 18,
    height: 18,
    fontSize: 10,
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 4px",
  },
  lastMsg: {
    display: "block",
    fontSize: 12,
    color: "#6b7280",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginBottom: 5,
  },
  tagsRow: { display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 6 },
  tag: {
    fontSize: 10,
    padding: "2px 6px",
    borderRadius: 4,
    fontWeight: 600,
    textTransform: "uppercase",
    backgroundColor: "#e5e7eb",
    color: "#374151",
  },
  tagBlue: { backgroundColor: "#dbeafe", color: "#1e40af" },
  tagGray: { backgroundColor: "#f3f4f6", color: "#374151" },
  tagAmber: { backgroundColor: "#fef3c7", color: "#92400e" },
  assignBtn: {
    fontSize: 11,
    padding: "3px 10px",
    border: "1px solid #d1d5db",
    borderRadius: 5,
    backgroundColor: "#fff",
    cursor: "pointer",
    color: "#374151",
    fontWeight: 500,
  },
  chatArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100%",
  },
  chatHeader: {
    padding: "14px 20px",
    borderBottom: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
  },
  chatHeaderName: { fontWeight: 600, fontSize: 15, color: "#111827", marginBottom: 2 },
  chatHeaderMeta: { fontSize: 12, color: "#6b7280" },
  primaryBtn: {
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 7,
    padding: "8px 18px",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
  },
  secondaryBtn: {
    backgroundColor: "#eff6ff",
    color: "#2563eb",
    border: "1px solid #bfdbfe",
    borderRadius: 7,
    padding: "8px 18px",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
  },
  messagesArea: {
    flex: 1,
    overflowY: "auto",
    padding: "20px",
    backgroundColor: "#f9fafb",
  },
  emptyMessages: {
    textAlign: "center",
    color: "#9ca3af",
    fontSize: 13,
    marginTop: 40,
  },
  messageRow: { display: "flex", marginBottom: 12 },
  bubble: {
    maxWidth: "70%",
    padding: "10px 14px",
    borderRadius: 14,
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  },
  bubbleText: { margin: 0, fontSize: 14, lineHeight: "1.5", wordBreak: "break-word" },
  bubbleTime: { display: "block", fontSize: 10, textAlign: "right", marginTop: 4 },
  typingBubble: {
    padding: "8px 14px",
    borderRadius: 12,
    backgroundColor: "#f3f4f6",
    color: "#4b5563",
    fontSize: 12,
    fontStyle: "italic",
  },
  inputArea: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "14px",
    background: "#fff",
    borderTop: "1px solid #e5e7eb",
  },
  textInput: {
    flex: 1,
    height: "46px",
    padding: "0 16px",
    borderRadius: "25px",
    border: "1px solid #ddd",
    fontSize: "14px",
    outline: "none",
    background: "#f9fafb",
  },
  sendBtn: {
    width: "46px",
    height: "46px",
    borderRadius: "50%",
    border: "none",
    background: "#2563eb",
    color: "white",
    fontSize: "20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "0.2s",
  },
  fileButton: {
    width: "42px",
    height: "42px",
    borderRadius: "50%",
    background: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "20px",
    flexShrink: 0,
  },
  selectedFile: {
    fontSize: "12px",
    color: "#6b7280",
    maxWidth: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  previewArea: {
    padding: "12px",
    background: "#f9fafb",
    borderTop: "1px solid #e5e7eb",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    position: "relative",
  },
  previewImage: {
    maxWidth: "120px",
    maxHeight: "120px",
    borderRadius: "8px",
    objectFit: "cover",
  },
  previewVideo: { maxWidth: "150px", borderRadius: "8px" },
  removePreview: {
    position: "absolute",
    top: "8px",
    right: "8px",
    width: "28px",
    height: "28px",
    border: "none",
    borderRadius: "50%",
    background: "#ef4444",
    color: "white",
    cursor: "pointer",
  },
  emptyState: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
    width: "100%",
    minHeight: "100%",
    background: "#fff",
  },
  imageModal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,.85)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  enlargedImage: {
    maxWidth: "90%",
    maxHeight: "90%",
    borderRadius: "12px",
    objectFit: "contain",
  },
  closeBtn: {
    position: "absolute",
    top: 20,
    right: 20,
    background: "transparent",
    border: "none",
    fontSize: 30,
    color: "#fff",
    cursor: "pointer",
  },
};

export default SupportChat;